import * as AppConstants from 'app/AppConstants';
import {
  fetchFeaturesFromStorage,
  fetchFeaturesFromUrl,
  addFeaturesToStorage,
  fetchFeaturesFromSwitcher,
} from './featureService';
import {load as loadEnvironment} from 'state/environment/environmentActions';

let cache = null;

export function loadFeatures() {
  return dispatch => {
    if (cache) return cache;

    dispatch({type: AppConstants.FEATURE__LOAD_FEATURES_STARTED});

    cache = Promise.all([
      dispatch(enableFeaturesBySession()),
      dispatch(enableFeaturesBySwitcher()),
      dispatch(loadEnvironment()),
    ]).then(
      () => {
        dispatch({type: AppConstants.FEATURE__LOAD_FEATURES_FINISHED});
      },
      () => {
        dispatch({type: AppConstants.FEATURE__LOAD_FEATURES_FAILED});
      }
    );

    return cache;
  };
}

export function enableFeaturesBySession() {
  return dispatch => {
    return fetchFeaturesFromStorage().then(features => {
      dispatch({
        type: AppConstants.FEATURE__FEATURES_LOADED_BY_SESSION,
        payload: {
          features,
        },
      });
    });
  };
}

export function enableFeaturesBySwitcher() {
  return dispatch => {
    return fetchFeaturesFromSwitcher().then(features => {
      dispatch({
        type: AppConstants.FEATURE__FEATURES_LOADED_BY_SWITCHER,
        payload: {
          features,
        },
      });
    });
  };
}

export function enableFeaturesByUrl() {
  return dispatch => {
    return fetchFeaturesFromUrl().then(features => {
      dispatch({
        type: AppConstants.FEATURE__FEATURES_LOADED_BY_URL,
        payload: {
          features,
        },
      });

      if (Object.keys(features).length > 0) {
        return addFeaturesToStorage(features);
      }
    });
  };
}
